// extracted by mini-css-extract-plugin
export default {"item":"CarouselItem_item__kEQN+"};